export default {"LABEL":"Theme 主题","DESC":"我们最推崇的就是主题模式了, 它可以很轻松的切换内置的不同样式, 我们目前支持 light 和 dark 两种风格可供选择.","COMPONENTS":{"__markdown":true}}